@for (controlModel of model; track trackByFn($index, controlModel)) {
<dynamic-material-form-control
  [group]="group"
  [hidden]="controlModel.hidden"
  [layout]="layout"
  [model]="controlModel"
  [templates]="templates"
  (blur)="onBlur($event)"
  (change)="onChange($event)"
  (focus)="onFocus($event)"
  (matEvent)="onCustomEvent($event, matEvent)"
  [getLanguage]="getLanguage"
  [class]="controlModel.id"
></dynamic-material-form-control>
} @for (item of formControlTerms; track item) {
<span class="control-terms" [ngClass]="item.class" [innerHTML]="item.key | cxTranslate"></span>
}
